import * as React from 'react';
import MyTypes from 'MyTypes';
import { connect, ConnectedProps } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps } from 'react-router';
import { Alert, Card, Form, Row, Col, Button, Accordion, Image, Spinner, Badge, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap'; 
import * as models from '../../models'; 
import _ from 'lodash'; 
import keyIcon from '../../assets/images/key.svg';
import { LuLink, LuHistory, LuFiles, LuSettings, LuRefreshCw, LuCheckCircle, LuAlertTriangle, LuCode, LuDatabase, LuXCircle, LuInfo, LuClock } from 'react-icons/lu'; 
import { companyActions } from 'store/companies';
import { contactsActions } from 'store/contacts';
import { locationActions } from 'store/locations';
import { securityActions } from 'store/security';
import { createPatch } from 'rfc6902';
import * as router from '../../services/router-service'; 
import { PhoneNumberType } from 'models/contacts/phoneNumber';
import { userActions } from 'store/user';
import { AppToastTypes } from 'models/enums'; 
import { userHasPermission } from 'utils/helpers';
import { USER_PERMISSIONS } from 'store/enums';
import { UserSecurityModal, SecurityOption } from '../security/userSecurityModal'; 
import AuditLogModal from './AuditLogModal'; 
import ContactMergeModal from './ContactMergeModal'; 

interface Props extends PropsFromRedux {    
}

interface State {
    contact: models.Contact, 
    isUpdated: boolean, 
    timer: ReturnType<typeof setTimeout>,
    showAuditModal: boolean;
    showMergeModal: boolean;
    showPayloadModal: boolean;
    showRoleModal: boolean; 
}

interface IReactRouterParams {
    contactId?: string; 
}

class ContactDetail extends React.Component<Props & RouteComponentProps<IReactRouterParams>, State> {  
    public state: State = {
        contact: models.defaultContact, 
        isUpdated: false,     
        timer: setTimeout(function(){}, 1000),
        showAuditModal: false,
        showMergeModal: false,
        showPayloadModal: false,
        showRoleModal: false
    }

    public componentDidMount() {
        const paging: models.Paging = { pageNo: 1, pageSize: 1000 }
        
        this.props.requestRoleList(); 
        this.props.requestPermissionList();
        this.props.requestCompanyDropdown(); 
        
        if(this.props.match.params.contactId !== '0')
            this.props.requestContact(parseInt(this.props.match.params.contactId!)); 
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (!_.isEqual(prevProps.contact, this.props.contact) || this.state.contact.contactId != this.props.contact.contactId) {            
            this.setState({contact: {...this.props.contact}}); 
        }

        if ( !_.isEqual(prevProps.zipSearch,this.props.zipSearch)) { 
            let contact: models.Contact = {
                ...this.state.contact,
                mailingAddress: {...this.props.contact.mailingAddress}
            }
            contact = {
                ...this.state.contact, 
                mailingAddress: {
                    ...this.state.contact.mailingAddress
                    , city: this.props.zipSearch.cityName
                    , state: this.props.zipSearch.stateName
                    , postalCode: this.props.zipSearch.zipCode
                }
            }
            this.setState({contact: contact}); 
        }

        if(!_.isEqual(prevState.contact?.mailingAddress?.postalCode, this.state.contact?.mailingAddress?.postalCode)) {
            this.handleTimelapse(); 
        }
    }

    handleTimelapse = () => {        
        clearTimeout(this.state.timer); 
        const zipCode = this.state.contact?.mailingAddress?.postalCode; 
        if (zipCode && zipCode !== '') {
            this.setState({ timer: setTimeout(() => { this.props.requestZipSearch(zipCode) }, 1000) });
        }
    }

    public submitForm = (e: any) => {
        e.preventDefault();
        const { contact } = this.state; 

        if(!contact.lastName){
            this.props.setAppToast({message: "Last Name Required", type: AppToastTypes.Failure });            
        }
        try {
            if(contact.contactId === 0) {      
                this.props.createContact(contact); 
            } else {
                const patchDocument = createPatch(this.props.contact, this.state.contact); 
                const contactId = this.props.contact.contactId;                
                this.props.updateContact(contactId, patchDocument, contact);
            }                        
        } catch (error) {
            console.error("Error saving contact", error);
        } finally {
            this.setState({isUpdated: false});             
        }
    }    

    public handleContactTypeChange = (e: any) => {
        let contactTypes = [...this.state.contact.contactTypes];
        if (!contactTypes.includes(e.target.name)) contactTypes.push(e.target.name);
        else contactTypes = contactTypes.filter(x => x !== e.target.name);
        this.setState({contact: {...this.state.contact, contactTypes: contactTypes}, isUpdated: true});
    }

    public handlePhoneNumberChange = (e: any) => {        
        const inputItem = e.target.name; 
        const inputvalue = e.target.value; 
        const targetType = inputItem as PhoneNumberType;
        const currentNumbers = this.state.contact.phoneNumbers || [];
        
        let phoneNumbers: models.PhoneNumber[]; 
        if (inputvalue !== "") {
            const newNumber: models.PhoneNumber = { phoneNumberType: targetType, phoneNumber: inputvalue };            
            phoneNumbers = currentNumbers.filter(x => x && x.phoneNumberType !== targetType).concat(newNumber); 
        } else {
            phoneNumbers = currentNumbers.filter(x => x && x.phoneNumberType !== targetType);
        }        
        this.setState({ contact: { ...this.state.contact, phoneNumbers: phoneNumbers }, isUpdated: true }); 
    }

    public handleManualSync = () => {
        if(this.state.contact.contactId > 0) {
            this.props.syncContact(this.state.contact.contactId);
        }
    }

    public handleCreateUser = () => { 
        const newUser: models.User = {
            userId: 0, 
            roles: [],
            permissions: [],
            isActive: true
        };

        this.setState({
            contact: { ...this.state.contact, user: newUser },
            isUpdated: true 
        });

        this.props.setAppToast({ 
            message: "Account details prepared. Click SUBMIT to create.", 
            type: AppToastTypes.Success
        });
    }
    public handleManageRoles = () => { console.log("Manage roles clicked"); }
    public handleBack = () => {router.goto(router.url.contacts);}

    // --- SECURITY HANDLERS ---
    public handleSaveSecurity = (roles: string[], permissions: string[]) => {
        if (!this.state.contact.user) return;

        this.setState({
            contact: {
                ...this.state.contact,
                user: {
                    ...this.state.contact.user,
                    roles: roles,
                    permissions: permissions
                }
            },
            isUpdated: true, 
            showRoleModal: false
        });
        
        this.props.setAppToast({
            message: "Roles & Permissions updated. Please click SUBMIT to save.", 
            type: AppToastTypes.Success
        });
    }

    public renderSecurityModal() {
        const { contact } = this.state;
        const { roleResponse, permissionResponse } = this.props;

        if(!contact.user) return null;

        const permIdToNameMap = new Map<number, string>();
        (permissionResponse?.resourceList || []).forEach(p => {
            if (p.permissionId && p.permissionName) {
                permIdToNameMap.set(p.permissionId, p.permissionName);
            }
        });

        const roleOptions: SecurityOption[] = (roleResponse?.resourceList || []).map(r => ({
            id: r.groupName, 
            name: r.groupName,
            grantedPermissionIds: (r.permissionIds || [])
                .map((id: number) => permIdToNameMap.get(id))
                .filter((name): name is string => !!name) 
        }));

        // 3. Map Permissions (Name -> ID)
        const permOptions: SecurityOption[] = (permissionResponse?.resourceList || []).map(p => ({
            id: p.permissionName,
            name: p.permissionName
        }));

        return (
            <UserSecurityModal 
                show={this.state.showRoleModal}
                onHide={() => this.setState({ showRoleModal: false })}
                onApply={this.handleSaveSecurity}
                userEmail={contact.email}
                availableRoles={roleOptions}
                availablePermissions={permOptions}
                initialRoles={contact.user.roles || []}
                initialPermissions={contact.user.permissions || []}
            />
        );
    }

    public render() {
        const { companyResponse, isContactLoading, isContactSyncing, isCompanyListLoading, isStateAbbrDDLoading, stateResponse } = this.props; 
        const { contact, isUpdated, showAuditModal, showMergeModal, showPayloadModal, showRoleModal } = this.state; 

        const isLinked = !!contact.connectAdjusterId;
        const isSynced = !!(contact.connectAdjusterId && contact.syncDate);
        const syncedFields = [
            'firstName', 'lastName', 'middleName', 'preferredName',
            'email', 'compassEmail', 'cell', 'mailingAddress',
            'xnAddress', 'xnAddress2'
        ];

        const shouldDisable = (fieldName: string) => isSynced && syncedFields.includes(fieldName);
        
        const syncDateDisplay = contact.syncDate ? new Date(contact.syncDate).toLocaleString() : 'Never';
        const objectPullDateDisplay = contact.connectObjDate ? new Date(contact.connectObjDate).toLocaleString() : 'None';
        const lastActivityDisplay = contact.user?.lastActivityDate ? new Date(contact.user.lastActivityDate).toLocaleString() : 'Never';

        const syncStatus = contact.syncStatus || 'Unknown';
        const isSyncSuccess = syncStatus === 'Success';
        const isSyncError = syncStatus !== 'Success' && syncStatus !== 'Unknown';

        const getFormattedPayload = () => {
            if (!contact.connectObj) return "No payload data available.";
            try {
                return JSON.stringify(typeof contact.connectObj === 'string' ? JSON.parse(contact.connectObj) : contact.connectObj, null, 2);
            } catch (e) { return String(contact.connectObj); }
        };

        const getUserRoles = () => {
            if(!contact.user) return "No Roles Assigned";
            if(!contact.user.roles || contact.user.roles.length === 0) return "No Roles Assigned";
            return contact.user.roles.join(", "); 
        }

        return (
            <>
            {contact &&                 
            <Form onSubmit={this.submitForm} style={{display: 'flex', flexDirection: 'column'}}>                                                                
                {/* --- Top Action Bar --- */}
                <Row className="mb-3 d-flex align-items-center justify-content-between">
                     <Col xs="auto" className="d-flex gap-2">
                        <button type="button" className="btn bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 shadow-sm d-inline-flex align-items-center gap-2" onClick={() => this.setState({showAuditModal: true})}>
                            <LuHistory className="w-4 h-4" /> <span>View Audit Log</span>
                        </button>
                        <button type="button" className="btn bg-white text-blue-700 border border-blue-200 hover:bg-blue-50 shadow-sm d-inline-flex align-items-center gap-2" onClick={() => this.setState({showMergeModal: true})}>
                             <LuFiles className="w-4 h-4" /> <span>Find Duplicates</span>
                        </button>
                     </Col>
                     <Col xs="auto">
                        <Button className="submit-contact-btn me-2" onClick={this.handleBack}>BACK</Button>
                        <Button className="submit-contact-btn" type="submit" disabled={!isUpdated}>SUBMIT</Button>
                     </Col>
                </Row>                

                {/* --- Sync Alert --- */}
                {isSynced && (
                    <Alert variant="info" className="mb-3 shadow-sm bg-cyan-50 border-cyan-200 text-cyan-800" style={{ borderLeft: '5px solid #0dcaf0' }}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <Alert.Heading className="d-flex align-items-center gap-2" style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                                    <LuRefreshCw className="w-5 h-5"/> Record Synced with Compass Connect
                                </Alert.Heading>
                                <p className="mb-0" style={{fontSize: '0.9rem'}}>Standard fields are read-only. Updates should be performed in the source system.</p>
                            </div>
                        </div>
                    </Alert>
                )}

                {/* --- Accordion Group --- */}
                <Accordion className="mb-3 shadow-sm" defaultActiveKey={[]} alwaysOpen>
                    
                    {/* 1. User Account Management */}
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>
                            <div className="d-flex align-items-center w-100">
                                <Image src={keyIcon} width={20} className="me-2" />
                                <strong>User Account Management</strong>
                                <div className="ms-auto me-3 d-flex align-items-center gap-3">
                                    {contact.user ? (
                                        <div onClick={(e) => e.stopPropagation()}>
                                            <Form.Check 
                                                type="switch"
                                                id="user-active-switch"
                                                label={contact.user.isActive ? "Active User" : "Inactive User"}
                                                checked={contact.user.isActive}
                                                className={contact.user.isActive ? "text-success fw-bold" : "text-danger fw-bold"}
                                                onChange={(e) => this.setState({
                                                    contact: { ...contact, user: { ...contact.user!, isActive: e.target.checked } }, 
                                                    isUpdated: true
                                                })}
                                            />
                                        </div>
                                    ) : (
                                        <Badge bg="light" text="dark" className="border">No Linked User</Badge>
                                    )}
                                </div>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            {contact.user ? (
                                <Row className="align-items-center">
                                    <Col md={8}>
                                            <p className="mb-1"><strong>Username:</strong> {contact.email} (Linked)</p>
                                            <p className="mb-1"><strong>Current Roles:</strong> {getUserRoles()}</p>
                                            <div className="mt-2 text-muted small d-flex align-items-center">
                                                <LuClock className="me-1"/> 
                                                <span>Last Activity: <strong>{lastActivityDisplay}</strong></span>
                                            </div>
                                    </Col>
                                    <Col md={4} className="text-end">
                                            <button 
                                                type="button"
                                                className="btn btn-sm bg-white text-sky-700 border border-sky-200 hover:bg-sky-50 d-inline-flex align-items-center gap-2"
                                                onClick={() => this.setState({showRoleModal: true})}
                                            >
                                                <LuSettings className="w-4 h-4"/>
                                                <span>Manage Roles / Perms</span>
                                            </button>
                                    </Col>
                                </Row>
                            ) : (
                                <div className="text-center py-2">
                                    <p className="text-muted mb-2">This contact does not have a login for Comtrack.</p>
                                    <Button variant="primary" size="sm" onClick={this.handleCreateUser}>Create User Account</Button>
                                </div>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    {/* 2. Connect Integration */}
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                             <div className="d-flex align-items-center w-100">
                                <LuLink className="w-5 h-5 me-2 text-primary" /> <strong>Connect Integration</strong>
                                <div className="ms-auto me-3"><Badge bg={isLinked ? "primary" : "secondary"}>{isLinked ? "Linked" : "Not Linked"}</Badge></div>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            <div className="bg-light p-3 rounded mb-4 border">
                                <Row className="g-3">
                                    <Col md={4}>
                                        <div className="d-flex flex-column h-100 justify-content-center">
                                            <span className="text-muted small text-uppercase fw-bold" style={{fontSize: '0.75rem'}}>Integration Status</span>
                                            
                                            <OverlayTrigger placement="top" overlay={<Tooltip id="link-status-tooltip">{isLinked ? `Linked to Connect ID: ${contact.connectAdjusterId}` : "Enter a Connect Adjuster ID to enable syncing."}</Tooltip>}>
                                                <div className="d-flex align-items-center mt-2 mb-1" style={{cursor: 'help'}}>
                                                    {/* CHANGE: Check icon matches linkage state */}
                                                    {isLinked ? <LuCheckCircle className="text-success me-2 w-4 h-4"/> : <LuInfo className="text-secondary me-2 w-4 h-4"/>}
                                                    <span className={isLinked ? "text-dark small" : "text-muted small"}>{isLinked ? "Link Configured" : "No Link Configured"}</span>
                                                </div>
                                            </OverlayTrigger>
                                            
                                            {isSynced && (
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="health-status-tooltip">{isSyncSuccess ? "Last sync completed successfully." : "Last sync failed. See error details below."}</Tooltip>}>
                                                    <div className="d-flex align-items-center" style={{cursor: 'help'}}>
                                                        {isSyncSuccess ? (<LuCheckCircle className="text-success me-2 w-4 h-4"/>) : (<LuXCircle className="text-danger me-2 w-4 h-4"/>)}
                                                        <span className={isSyncSuccess ? "text-success fw-bold" : "text-danger fw-bold"}>{isSyncSuccess ? "Healthy" : "Sync Failed"}</span>
                                                    </div>
                                                </OverlayTrigger>
                                            )}
                                        </div>
                                    </Col>
                                    <Col md={4} className="border-start border-end">
                                            <div className="d-flex flex-column">
                                                <span className="text-muted small text-uppercase fw-bold mb-2" style={{fontSize: '0.75rem'}}>Data Freshness</span>
                                                <div className="d-flex justify-content-between small mb-1">
                                                    <span className="text-secondary"><LuRefreshCw className="inline-block me-1" style={{width:'12px'}}/> Last Sync:</span>
                                                    <span className="font-monospace fw-bold text-dark">{syncDateDisplay}</span>
                                                </div>
                                                <div className="d-flex justify-content-between small">
                                                    <span className="text-secondary"><LuDatabase className="inline-block me-1" style={{width:'12px'}}/> Last Object Pull:</span>
                                                    <span className="font-monospace fw-bold text-dark">{objectPullDateDisplay}</span>
                                                </div>
                                            </div>
                                    </Col>
                                    <Col md={4}>
                                            <div className="d-flex flex-column align-items-end justify-content-center h-100 gap-2">
                                                <div className="d-flex gap-2">
                                                    <OverlayTrigger placement="top" overlay={<Tooltip id="json-tooltip">View raw Connect JSON payload</Tooltip>}>
                                                        <Button variant="outline-secondary" size="sm" className="d-flex align-items-center bg-white" onClick={() => this.setState({showPayloadModal: true})} disabled={!contact.connectObj}>
                                                            <LuCode className="me-1"/> Payload
                                                        </Button>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger placement="top" overlay={<Tooltip id="sync-tooltip">Trigger manual sync</Tooltip>}>                                                        
                                                        <Button variant="primary" size="sm" className="d-flex align-items-center" onClick={this.handleManualSync} disabled={isContactSyncing || !isLinked}>
                                                            {isContactSyncing ? <Spinner as="span" animation="border" size="sm" className="me-1"/> : <LuRefreshCw className="me-1"/>}
                                                            {isContactSyncing ? "Syncing" : "Sync Now"}
                                                        </Button>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                    </Col>
                                </Row>
                            </div>
                            {isSynced && isSyncError && (
                                <Alert variant="danger" className="mb-4 d-flex align-items-start small">
                                    <LuAlertTriangle className="flex-shrink-0 me-2 mt-1 w-5 h-5" />
                                    <div><strong>Sync Error:</strong> {contact.syncError || "Unknown error occurred during last sync."}</div>
                                </Alert>
                            )}
                            <div className="mb-2">
                                <h6 className="text-muted small text-uppercase fw-bold mb-3 border-bottom pb-2">Link Configuration</h6>
                                <Row>
                                    <Col md={6}>
                                            <Form.Group controlId="formConnectAdminId">
                                                <Form.Label>Connect Admin ID</Form.Label>
                                                <Form.Control type="number" placeholder="Enter Admin ID..." value={contact.connectAdminId || ""} onChange={(e) => this.setState({contact: {...contact, connectAdminId: parseInt(e.target.value)}, isUpdated: true})} disabled={!userHasPermission(USER_PERMISSIONS.CAN_MANAGE_CONNECT_LINK)}/>
                                                <Form.Text className="text-muted small">Required for Admin token linking</Form.Text>
                                            </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                            <Form.Group controlId="formConnectAdjusterId">
                                                <Form.Label>Connect Adjuster ID</Form.Label>
                                                <Form.Control type="number" placeholder="Enter Adjuster ID..." value={contact.connectAdjusterId || ""} onChange={(e) => this.setState({contact: {...contact, connectAdjusterId: parseInt(e.target.value)}, isUpdated: true})} disabled={!userHasPermission(USER_PERMISSIONS.CAN_MANAGE_CONNECT_LINK)}/>
                                                <Form.Text className="text-muted small"><strong>Primary Sync Key.</strong> Required for syncing contact data</Form.Text>
                                            </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <Card className="claim-card">
                    <Card.Title className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            Contact Info 
                            {isContactLoading && <Spinner animation="border" role="status" variant="primary" size="sm" className="ms-2"/>}
                        </div>
                        {/* --- STATS BADGES (Added) --- */}
                        <div className="d-flex gap-2" style={{fontSize: '0.9rem'}}>
                            <Badge bg="light" text="dark" className="border d-flex align-items-center px-2 py-1">
                                <span className="fw-bold me-1">{contact.totalClaims || 0}</span> 
                                <span className="fw-normal text-muted">Total Claims</span>
                            </Badge>
                            <Badge bg="primary" className="d-flex align-items-center px-2 py-1 shadow-sm">
                                <span className="fw-bold me-1">{contact.activeClaims || 0}</span>
                                <span className="fw-normal">Active</span>
                            </Badge>
                        </div>
                    </Card.Title>                   
                    <Card.Body>
                        <Row className="mb-3">
                            <Form.Group as={Col} id="formIsActive">
                                <Form.Check type="checkbox" label="Active Contact" checked={contact.isActive || false} onChange={(e) => this.setState({contact: {...contact, isActive: !contact.isActive}, isUpdated: true})}/>
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formFirstName"><Form.Label>First Name {shouldDisable('firstName') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="text" disabled={shouldDisable('firstName')} placeholder="Enter First Name..." value={contact.firstName || ""} onChange={(e) => this.setState({contact: {...contact, firstName: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} controlId="formMiddleName"><Form.Label>Middle Name</Form.Label><Form.Control type="text" disabled={shouldDisable('middleName')} placeholder="Enter Middle Name..." value={contact.middleName || ""} onChange={(e) => this.setState({contact: {...contact, middleName: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} controlId="formLastName"><Form.Label>Last Name {shouldDisable('lastName') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="text" disabled={shouldDisable('lastName')} placeholder="Enter Last Name..." value={contact.lastName || ""} onChange={(e) => this.setState({contact: {...contact, lastName: e.target.value}, isUpdated: true})}/></Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md={4} controlId="formPreferredName"><Form.Label>Preferred Name</Form.Label><Form.Control type="text" disabled={shouldDisable('preferredName')} placeholder="Enter Preferred Name..." value={contact.preferredName || ""} onChange={(e) => this.setState({contact: {...contact, preferredName: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} md={4} controlId="formEmail"><Form.Label>Email {shouldDisable('email') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="email" disabled={shouldDisable('email')} placeholder="Enter Email Address..." value={contact.email || ""} onChange={(e) => this.setState({contact: {...contact, email: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} md={4} controlId="formCompassEmail"><Form.Label>Compass Email {shouldDisable('compassEmail') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="email" disabled={shouldDisable('compassEmail')} placeholder="Enter Compass Email..." value={contact.compassEmail || ""} onChange={(e) => this.setState({contact: {...contact, compassEmail: e.target.value}, isUpdated: true})}/></Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} md={3} controlId="formTitle"><Form.Label>Title</Form.Label><Form.Control name="title" type="text" placeholder="Enter Title..." value={contact.title || ""} onChange={(e) => this.setState({contact: {...contact, title: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} md={3} controlId="formCompany"><Form.Label>Company</Form.Label><Form.Select name="companies" value={contact.companyName} onChange={(e) => this.setState({contact: {...contact, companyName: e.target.value}, isUpdated: true})}>{isCompanyListLoading && <option>Loading...</option>}{!isCompanyListLoading && <option key={-1}>Choose...</option>}{companyResponse.resourceList?.map((c: models.DropDownListItem, i: number) => (<option key={i} value={c.name} >{c.name}</option>))}</Form.Select></Form.Group>
                            <Form.Group as={Col} md={3} controlId="formXnAddress"><Form.Label>XnAddress {shouldDisable('xnAddress') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="text" disabled={shouldDisable('xnAddress')} placeholder="Enter Xn Address..." value={contact.xnAddress || ""} onChange={(e) => this.setState({contact: {...contact, xnAddress: e.target.value}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} md={3} controlId="formXnAddress2"><Form.Label>XnAddress 2 {shouldDisable('xnAddress2') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control type="text" disabled={shouldDisable('xnAddress2')} placeholder="Enter Xn Address 2..." value={contact.xnAddress2 || ""} onChange={(e) => this.setState({contact: {...contact, xnAddress2: e.target.value}, isUpdated: true})}/></Form.Group>
                        </Row>
                        <Row>
                            <Form.Group className="checkbox-group-hor">
                                {["Adjuster", "Admin", "Examiner", "Field Adjuster", "Field Director", "Reviewer"].map(type => (
                                    <Form.Check key={type} inline={true} name={type} type="checkbox" label={type} id={`chk${type.replace(/\s/g, '')}`} checked={contact.contactTypes?.includes(type) ? true : false} onChange={this.handleContactTypeChange}/>
                                ))}
                            </Form.Group>
                        </Row>
                    </Card.Body>
                </Card>                     

                <Card className="claim-card">
                    <Card.Title>Contact Numbers</Card.Title>
                    <Card.Body>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formCell"><Form.Label>Cell {shouldDisable('cell') && <i className="text-muted fa fa-lock ms-1"/>}</Form.Label><Form.Control name="Cell" type="text" disabled={shouldDisable('cell')} placeholder="Enter Cell #..." value={contact.phoneNumbers?.find(p => p?.phoneNumberType == PhoneNumberType.Cell)?.phoneNumber || ''} onChange={this.handlePhoneNumberChange}/></Form.Group>
                            <Form.Group as={Col} controlId="formHome"><Form.Label>Home</Form.Label><Form.Control name="Home" type="text" placeholder="Enter Home #..." value={contact.phoneNumbers?.find(p => p?.phoneNumberType == PhoneNumberType.Home)?.phoneNumber || ''} onChange={this.handlePhoneNumberChange}/></Form.Group>
                            <Form.Group as={Col} controlId="formBusiness"><Form.Label>Business</Form.Label><Form.Control name="Business" type="text" placeholder="Enter Business #..." value={contact.phoneNumbers?.find(p => p?.phoneNumberType == PhoneNumberType.Business)?.phoneNumber || ''} onChange={this.handlePhoneNumberChange}/></Form.Group>
                        </Row>
                    </Card.Body>
                </Card>

                {/* ... Address Card ... */}
                <Card className="claim-card">
                    <Card.Title>Mailing Address {shouldDisable('mailingAddress') && <i className="text-muted fa fa-lock ms-1" style={{fontSize: '0.8rem'}}/>}</Card.Title>
                    <Card.Body>
                         <Row className="mb-3">
                            <Form.Group as={Col} controlId="formAddress1"><Form.Label>Address</Form.Label><Form.Control placeholder="Enter Street Number..." disabled={shouldDisable('mailingAddress')} value={contact.mailingAddress?.addressLine1 || ""} onChange={(e) => this.setState({contact: {...contact, mailingAddress: {...contact.mailingAddress, addressType: "Mailing", addressLine1: e.target.value}}, isUpdated: true})}/></Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formCity"><Form.Label>City</Form.Label><Form.Control placeholder='Enter City...' disabled={shouldDisable('mailingAddress')} value={contact.mailingAddress?.city || ""} onChange={(e) => this.setState({contact: {...contact, mailingAddress: {...contact.mailingAddress, addressType: "Mailing", city: e.target.value}}, isUpdated: true})}/></Form.Group>
                            <Form.Group as={Col} controlId="formState"><Form.Label>State</Form.Label><Form.Select name="states" disabled={shouldDisable('mailingAddress')} value={contact.mailingAddress?.state || ""} onChange={(e) => this.setState({contact: {...contact, mailingAddress: {...contact.mailingAddress, addressType: "Mailing", state: e.target.value}}, isUpdated: true})}>{isStateAbbrDDLoading && <option>Loading...</option>}{!isStateAbbrDDLoading && <option key={-1}>Choose...</option>}{stateResponse && stateResponse.resourceList?.map((s: models.DropDownListItem, i: number) => ( <option key={i} value={s.name} >{s.name}</option>))}</Form.Select></Form.Group>
                            <Form.Group as={Col} controlId="formZip"><Form.Label>Zip</Form.Label><Form.Control placeholder='Enter Zip...' disabled={shouldDisable('mailingAddress')} value={contact.mailingAddress?.postalCode  || ""} onChange={(e) => this.setState({contact: {...contact, mailingAddress: {...contact.mailingAddress, postalCode: e.target.value}}, isUpdated: true})}/></Form.Group>
                        </Row>
                    </Card.Body>
                </Card>
            </Form>
            }

            {/* --- Audit Log Modal Placeholder --- */}
            <AuditLogModal 
                show={this.state.showAuditModal}
                onHide={() => this.setState({ showAuditModal: false })}
                contactId={this.state.contact.contactId}
            />

            {/* --- Merge Modal Placeholder --- */}
            <ContactMergeModal 
                show={this.state.showMergeModal}
                onHide={() => this.setState({showMergeModal: false})}
                currentContact={this.state.contact} 
            />

            {/* --- Payload Viewer Modal --- */}
            <Modal show={showPayloadModal} onHide={() => this.setState({showPayloadModal: false})} size="lg">
                <Modal.Header closeButton><Modal.Title>Connect Object (Raw JSON)</Modal.Title></Modal.Header>
                <Modal.Body><pre className="bg-light p-3 border rounded" style={{maxHeight: '600px', overflowY: 'auto', fontSize: '0.85rem'}}>{getFormattedPayload()}</pre></Modal.Body>
                <Modal.Footer><Button variant="secondary" onClick={() => this.setState({showPayloadModal: false})}>Close</Button></Modal.Footer>
            </Modal>

            {/* --- User Security Modal --- */}
            {showRoleModal && this.renderSecurityModal()}
            
            </>
        );        
    }

}

const mapStateToProps = (state: MyTypes.RootState) => ({
    companyResponse: state.companies.dropdowns.companyDD,
    contact: state.contacts.contacts.contact,
    isContactLoading: state.contacts.contacts.isContactLoading,
    isContactSyncing: state.contacts.contacts.isContactSyncing,
    isCompanyListLoading: state.companies.dropdowns.isCompanyDDLoading,
    isRoleListLoading: state.admin.admin.isRoleListLoading,             
    isStateAbbrDDLoading: state.locations.dropdowns.isStateDDLoading,
    roleResponse: state.security.groups.Auth2GroupResponse,
    permissionResponse: state.security.permissions.Auth2PermissionResponse, 
    stateResponse: state.locations.dropdowns.stateDD,    
    zipSearch: state.locations.locations.zipSearch
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {            
            createContact: contactsActions.createContact, 
            requestCompanyDropdown: companyActions.requestAllCompaniesDD,
            requestContact: contactsActions.requestContact,
            requestRoleList: securityActions.requestGroups,             
            requestPermissionList: securityActions.requestPermissions,
            requestZipSearch: locationActions.requestZipSearch,
            setAppToast: userActions.setAppToast, 
            syncContact: contactsActions.requestContactSync, 
            updateContact: contactsActions.updateContact, 
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ContactDetail);